window.slate = window.slate || {};
window.theme = window.theme || {};

// Global vars
window.theme.classes = {
  noScroll: 'no-scroll',
  processing: 'is-processing',
  loading: 'is-loading',
  visible: 'is-visible',
  hidden: 'is-hidden',
  success: 'is-success',
  error: 'is-error',
  active: 'is-active'
};

var $html = $('html');
var $body = $('body');
var $window = $(window);
var sections;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Modules ================*/
/*
  WINDOW RESIZE
  Purpose: functions bound to window.resize can be memory intensive when fired constantly. This helper instead throttles window.resize with a delay for performance gains
  Usage/example:
    theme.windowResize(yourScrollBasedFunction,scrollDelayInMilliseconds)
*/

theme.windowResize = (function(){

  var init = function(taskFunction,resizeDelay) {

    console.log('windowResize.init');

    // VARS
    var self = this,
        timeout,
        resizeDelay = (typeof resizeDelay === "undefined" ? 250 : resizeDelay); // default 250

    // ACTION
    $(window).on('resize', function() {
      clearTimeout(timeout); // clear the timeout
      timeout = setTimeout(taskFunction,resizeDelay); // start timing for event "completion"
    });

  };

  return {
    init: init
  }
})();

/*
  WINDOW SCROLL
  Purpose: functions bound to window.scroll can be memory intensive when fired constantly. This helper instead throttles window scroll with delay for performance gains
  Usage/example:
    theme.windowScroll(yourScrollBasedFunction,scrollDelayInMilliseconds)
*/

theme.windowScroll = (function(){

  var init = function(taskFunction,scrollDelay) {

    console.log('windowScroll.init');

    // VARS
    var self = this,
        timeout,
        scrollDelay = (typeof scrollDelay === 'undefined' ? 250 : scrollDelay); // default 250

    // ACTION
    $(window).on('scroll', function() {
      clearTimeout(timeout); // clear the timeout
      timeout = setTimeout(taskFunction,scrollDelay); // start timing for event "completion"
    });

  };

  return {
    init: init
  }
})();

/*
  FORM VALIDATION
  Dependency: http://jqueryvalidation.org
  Purpose: Enhances basic HTML5 validation attributes and allows styling/positioning of errors
  Usage: Use HTML5 validation attributes as standard. For custom error messages, use data-msg-[attribute]
  Example:
    <input type="text" required data-msg-required="Field required" minlength="4" data-msg-minlength="4 characters min" />

  Extended functionality:
    - Clear/reset form triggers (data-validate-clear)
*/

theme.formValidation = (function(){

  var init = function() {

    var $forms = $('[data-validate]');
    if (!$forms.length) { return; } // quit if not needed

    console.log('formValidation.init');

    // VARS
    var self = this;

    // fn. clear validation
    function clearValidation($form) {
      var validator = $form.validate(); // get validation instance

      // reset default error stuff
      validator.resetForm(); // remove error class on name elements and clear history
      validator.reset(); // remove all error and success data
      $form.find('.error').removeClass('error'); // remove any error classes (bug with validator)
      $form.trigger('reset'); // reset form
    }

    // ACTION
    $forms.each(function() {
      var $form = $(this),
          $triggerClear = $('[data-validate-clear]');

      // default options
      var validationOptions = {
        errorPlacement: function($error, $field) {
          var $fieldWrapper = $field.closest('.f-item');
          if ($fieldWrapper.length) {
            $error.appendTo($fieldWrapper);
          } else {
            $error.insertAfter($field);
          }
          $error.addClass('f-error');
        }
      };

      // bind validation
      $form.validate(validationOptions);

      // bind clear triggers
      $triggerClear.on('click', function(e) {
        clearValidation($form);
      });

    });

  };

  return {
    init: init
  }
})();

/*
  TOGGLER
  Purpose: allow the toggle of element state via trigger/s
*/

theme.toggler = (function(){

  var init = function() {

    var $triggers = $('[data-toggler-trigger]');
    if (!$triggers.length) { return; } // quit if not needed

    console.log('toggler.init');

    // VARS
    var self = this;

    // ACTION
    $triggers.each(function(index, trigger) {
      var $target = $(trigger).closest('[data-toggler-target]');

      // toggle when triggering
      $(trigger).on('click', function(e) {
        e.preventDefault();
        $target.toggleClass(window.theme.classes.active);
      });

      // close when clicking outside
      $(document).on('click',function (e) {
        if (!$target.is(e.target) && $target.has(e.target).length === 0 && $target.hasClass(window.theme.classes.active)) {
          $target.removeClass(window.theme.classes.active);
        }
      });

    });

  };

  return {
    init: init
  }
})();

/*
  NUMBER CONTROL
  Purpose: Provide plus/minus buttons for numerical input fields
  Usage/example:
    <span class="f-number-control" data-number-control>
      <button type="button" class="f-number-control__btn f-number-control__btn--minus" data-number-control-btn="minus">-</button>
      <input type="number" class="f-number-control__input" data-number-control-input name="" id="" aria-label="" value="" min="0" max="10" />
      <button type="button" class="f-number-control__btn f-number-control__btn--plus" data-number-control-btn="plus">+</button>
    </span>
*/

theme.numberControl = (function(){

  var init = function() {
    console.log('numberControl.init');

    var self = this;

    // click to change number (AJAX ready)
    $('html').on('click', '[data-number-control-btn]', function(e) {
      e.preventDefault();

      var $btn = $(this),
          $wrap = $btn.parents('[data-number-control]'),
          $input = $wrap.find('[data-number-control-input]'),
          action = $btn.attr('data-number-control-btn'),
          currentVal = parseInt($input.val()),
          minVal = $input.attr('min') || 0,
          maxVal = $input.attr('max') || 9999;

        // if value is not a number, set it to 0
        if (isNaN(currentVal)) { currentVal = 0; $input.val(currentVal);  }

        // if plus and not max val
        if (action == 'plus' && currentVal < maxVal) { $input.val(currentVal + 1); }

        // if minus and not min val
        if (action == 'minus' && currentVal > minVal) { $input.val(currentVal - 1); }

        // trigger change event for any other JS behaviour
        $input.change();

    });

  };

  return {
    init: init
  }
})();

/*
  CART
  Purpose: all AJAX functionality relating to cart
*/

theme.cart = (function(){

  var init = function() {

    console.log('cart.init');

    // VARS
    var self = this,
        $counts = $('[data-cart-count]'), // anywhere to update basket count
        $totals = $('[data-cart-total]'), // anywhere to update basket total cost
        formSelector = '[data-add-to-cart-form]',
        formBtnSelector = '[data-add-to-cart]',
        formMsgSuccessSelector = '[data-add-to-cart-msg="success"]',
        $submittedForm;

    // FN: HANDLE ERRORS
    function handleMiniBasketError(consoleMsg,textStatus,xhr) {
      var responseJSON = xhr['responseJSON'];
      alert(responseJSON['message'] + ': ' + responseJSON['description'] + ' (#' + responseJSON['status'] + ')');
    };

    // FN: UPDATE CART REFS
    function updateCartRefs() {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json'
      }).done(function(cartData) { // if successful
        console.log('Cart data',cartData);
        $counts.text(cartData['item_count']);
        $totals.text(slate.Currency.formatMoney(cartData['total_price']));
      }).fail(function(xhr,textStatus) { // if fail
        handleMiniBasketError('Failed to get cart data',textStatus,xhr);
      });
    };

    // FN: ADD TO CART
    function addItemToCart(formDataJSON) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formDataJSON,
        dataType: 'json',
        beforeSend: function() {
          $submittedForm.find(formBtnSelector).prop('disabled',true).addClass(theme.classes.processing); // disable button
          $submittedForm.find(formMsgSuccessSelector).removeClass(theme.classes.visible); // hide any previous success message
        }
      }).done(function(itemData) { // if successful
        console.log('AJAX added to cart',itemData);
        $submittedForm.find(formMsgSuccessSelector).addClass(theme.classes.visible); // show success message
        updateCartRefs(); // update refs
        if ($submittedForm.is('[data-add-to-cart-form="reload"]')) { window.location.reload(); } // reload page if flag is set
      }).fail(function(xhr,textStatus) { // if fail
        handleMiniBasketError('Failed to add to cart',textStatus,xhr);
      }).always(function() {
        $submittedForm.find(formBtnSelector).prop('disabled',false).removeClass(theme.classes.processing); // re-instate button
      });
    };

    // ACTION

    // ADD PRODUCT FORM SUBMIT
    $body.on('submit', formSelector, function(e) {
      e.preventDefault();

      var $form = $(this),
          formData = $form.serializeArray(),
          formJSON = {};

      // JSON tha' data
      $.each(formData, function(i, v) {
        formJSON[v.name] = v.value;
      });

      // AJAX add to cart
      $submittedForm = $form;
      addItemToCart(formJSON);
    });

  };

  return {
    init: init
  }
})();
/*
  MOBILE MENU
  Dependency: http://mmenu.frebsite.nl/
  Purpose: Provide slide out menu
*/

theme.mobileNav = (function () {

  var init = function() {
    var $nav = $('#mobile-nav');
    if (!$nav.length) { return; } // quit if not needed

    console.log('mobileNav.init');

    // VARS
    var self = this,
        canvasSelector = '[data-mobile-nav-canvas]',
        $navClose = $nav.find('[data-mobile-nav-close]');

    // FN: SETUP MMENU
    var setup = function() {
      $nav.mmenu({
        navbar: {
            title: ""
        },
        extensions: [
          'pagedim-black',
          'multiline',
          'position-front'
        ],
        // navbar: false,
        keyboardNavigation: {
          enabled: true,
          enhance: true
        }
      }, {
        // configuration
        offCanvas: {
          pageSelector: canvasSelector
        },
        classNames: {
          selected: 'link-active'
        }
      });
    };

    // ACTION
    setup();

    $navClose.on('click', function(e) {
      e.preventDefault();
      $nav.data('mmenu').close();
    });

  };

  return {
    init: init
  }

})();

/*
  SELECT NAV
  Purpose: Allow a select menu to function as navigation
*/

theme.selectNav = (function(){

  var init = function() {

    var $selectNavs = $('[data-select-nav]');
    if (!$selectNavs.length) { return; } // quit if not needed

    console.log('selectNav.init');

    // VARS
    var self = this;

    // ACTION
    $selectNavs.on('change', function(e) {
      var $select = $(this),
		  newurl,
          url = $select.find('option:selected').val();

      console.log(url);

      if (url.indexOf('#') === 0) { // in-page hash
        if ($(url).length) {
          	$('html, body').animate({ scrollTop: $(url).offset().top }, 600, 'swing');
			
			newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
			window.history.pushState({ path: newurl }, '', newurl);


        }

      } else { // external link
        window.location.href = url;
      }

    });

  };

  return {
    init: init
  }
})();

/*
  QUICKBUY
  Dependencies: https://github.com/dimsemenov/Magnific-Popup
  Purpose: launches quickbuy lightbox
*/

theme.quickBuy = (function(){

  var init = function() {

    var $triggers = $('[data-quickbuy]');
    if (!$triggers.length) { return; } // quit if not needed

    console.log('quickBuy.init');

    // VARS
    var self = this;

    // ACTION
    $triggers.each(function(index, $trigger) {
      var $trigger = $(this),
          url = $trigger.attr('data-quickbuy') || $trigger.attr('href');

      // initiate modal
      $trigger.magnificPopup({
        items: {
          src: url,
          type: 'ajax',
        },
        disableOn: 750, // disable below 750
        fixedContentPos: true,
        callbacks: {
          beforeOpen: function() { $html.addClass(window.theme.classes.noScroll); },
          ajaxContentAdded: function() { sections.register('product', theme.Product); theme.optionFilter.init(); },
          afterClose: function() { $html.removeClass(window.theme.classes.noScroll); },
        }
      });

    });

  };

  return {
    init: init
  }
})();

/*
  STICK
  Purpose: Stick or 'pin' elements during scroll, then unstick when reaching certain scroll position. On a parent element, use data-stick-parent and any data-stick elements within will be 'pinned' only within the constraints of the parent. Optionally specify a top offset with data-stick-offset and a breakpoint at which to enable, using data-stick-enable-at. Flexbox/set heights can be useful for this purpose. Please avoid hardcoded heights that could be subject to change.
  Dependency: http://leafo.net/sticky-kit/
  Usage/example:
    <div data-stick-parent>
      I am the constraining parent
      <div data-stick data-stick-offset="60" data-stick-enable-at="900">I will be 'pinned' within the parent, with an offset of 60 and only 900px and above</div>
    </div>
*/

theme.stick = (function(){

  var init = function() {
    var $instances = $('[data-stick]');
    if (!$instances.length) { return; } // quit if not needed

    console.log('stick.init');

    // // VARS
    var self = this;

    // FN: Toggle stickiness
    function toggleSticky($stickyInstance,options,breakpoint) {
      if ($window.width() < breakpoint) {
        $stickyInstance.trigger('sticky_kit:detach');
      } else {
        $stickyInstance.stick_in_parent(options);
      }
    }

    // Setup each instance
    $instances.each(function() {

      var $instance = $(this),
          $parent = $instance.closest('[data-stick-parent]') || $instance.parent();
          breakpointEnable = parseInt($instance.attr('data-stick-enable-at')) || 0,
          stickyOffset = parseInt($instance.attr('data-stick-offset')) || 0,
          stickyOptions = {};

      // Options
      stickyOptions = {
        parent: $parent,
        offset_top: stickyOffset,
        spacer: false
      };

      // init/toggle
      toggleSticky($instance,stickyOptions,breakpointEnable);

      // if we have a breakpoint to listen for
      if (breakpointEnable > 0) {
        theme.windowResize.init(function() {
          toggleSticky($instance,stickyOptions,breakpointEnable);
        },250);
      }

    });

  };

  return {
    init: init
  }
})();

/*
  OPTION FILTER
  Purpose: filter available options when selecting first option
  IMPORTANT: Does not currently work with 3x options!!
*/

theme.optionFilter = (function(){

  var init = function() {

    var $dropdown1 = $('[data-option-filter="1"]');
    if (!$dropdown1.length) { return; } // quit if not needed

    console.log('optionFilter.init');

    // VARS
    var self = this,
        $dropdown2 = $('[data-option-filter="2"]'),
        productJSON = JSON.parse($('[data-product-json]').html());

    // WHEN CHANGING DROPDOWN 1
    $dropdown1.on('change', function() {
      var selectedValue1 = $dropdown1.val(),
          $options2 = $dropdown2.find('option');
      
      // set all options unavailable first
      $options2.addClass(window.theme.classes.hidden).prop('disabled',true);

      // then check and set available products
      $options2.each(function(index) {
        var $currentOption = $(this),
            currentValue = $currentOption.val(),
            firstSelected = false;

        $.each(productJSON.variants, function(index, variant) {
          if (selectedValue1 == variant.option1 && currentValue == variant.option2) {
            $currentOption.removeClass(window.theme.classes.hidden).prop('disabled',false);
          }
        });
      });

      // make sure first available option is selected by default
      $options2.not('.' + window.theme.classes.hidden).first().prop('selected',true);

      // trigger change to update variant dropdown
      $dropdown2.trigger('change');

    }).trigger('change'); // trigger on load

  };

  return {
    init: init
  }
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    bulkDiscountMessage: '[data-bulk-discount-message]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;
      if (variant) {
        console.log(variant.sku, window.Shopify.bulkDiscountSkus.includes(variant.sku))
      }
      if (
        variant && variant.sku &&
        window.Shopify &&
        window.Shopify.bulkDiscountSkus &&
        window.Shopify.bulkDiscountSkus.includes(variant.sku)
      ) {
        $(selectors.bulkDiscountMessage, this.$container).removeClass('hide');
      } else {
        $(selectors.bulkDiscountMessage, this.$container).addClass('hide');
      }

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  var a11ySanitizedWindowHash = $.escapeSelector(window.location.hash).replace(/^\\/, '');
  slate.a11y.pageLinkFocus($(a11ySanitizedWindowHash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // FLUID VIDEO
  $body.fitVids();

  // CAROUSELS
  // Override/extend default settings via inline JSON, e.g. data-slick='{"slidesToShow": 4, "slidesToScroll": 4}'
  $('[data-slick]').slick({
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    mobileFirst: true
  });

  // MODALS
  $('[data-mfp]').each(function(index,instance) {
    var defaults = {
      fixedContentPos: true,
      callbacks: {
        beforeOpen: function() { $html.addClass(window.theme.classes.noScroll); },
        afterClose: function() { $html.removeClass(window.theme.classes.noScroll); },
      }
    };
    var dataAttrOptions = JSON.parse($(instance).attr('data-mfp')); // allow options to be specified via data attribute JSON
    var options = $.extend({}, defaults, dataAttrOptions);
    $(instance).magnificPopup(options);
  });
  $(document).on('click', '[data-mfp-dismiss]', function (e) { // allow modal dismiss
    $.magnificPopup.close();
  });

  // INIT
  theme.formValidation.init();
  theme.toggler.init();
  theme.numberControl.init();
  theme.cart.init();
  theme.mobileNav.init();
  theme.selectNav.init();
  theme.quickBuy.init();
  theme.stick.init();
  theme.optionFilter.init();

});
